// product-description-toggle.js
// 严格保持原有DOM结构，仅展开描述容器，不移动按钮位置
document.addEventListener('DOMContentLoaded', function() {
  // 防止重复初始化
  if (window.__PRODUCT_DESCRIPTION_TOGGLE_INIT__) return;
  window.__PRODUCT_DESCRIPTION_TOGGLE_INIT__ = true;

  // 选择所有展开按钮（严格匹配原有class）
  const toggleButtons = document.querySelectorAll('.product-description-toggle.view-all-button');
  
  if (!toggleButtons.length) return;

  // 绑定点击事件（核心：仅修改容器高度，不移动任何元素）
  toggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // 获取目标描述容器（严格通过data-target-id匹配）
      const targetId = this.getAttribute('data-target-id');
      const descriptionContainer = document.getElementById(targetId);
      if (!descriptionContainer) return;

      // 判断当前展开状态
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (isExpanded) {
        // 收起：仅恢复容器的折叠类和基础样式，不修改其他
        descriptionContainer.classList.add('collapsed', 'overlay');
        descriptionContainer.style.maxHeight = '';
        descriptionContainer.style.overflow = '';
        
        // 恢复按钮文字和状态
        this.querySelector('.button-text').textContent = 'VIEW ALL';
        this.setAttribute('aria-expanded', 'false');
      } else {
        // 展开：仅移除高度限制，保留按钮在容器内的原始位置
        descriptionContainer.classList.remove('collapsed', 'overlay');
        // 关键：只修改maxHeight为内容自然高度，不改动其他样式/位置
        descriptionContainer.style.maxHeight = descriptionContainer.scrollHeight + 'px';
        descriptionContainer.style.overflow = 'visible';
        
        // 更新按钮文字和状态
        this.querySelector('.button-text').textContent = 'SHOW LESS';
        this.setAttribute('aria-expanded', 'true');
      }
      
      // 强制触发布局重排，确保下方模块被顶开但按钮位置不变
      requestAnimationFrame(() => {
        descriptionContainer.offsetHeight;
      });
    });
  });
});